import styled, { css } from 'styled-components';

import {
    Image,
    mediaMixin,
    spaceMixin,
    Spacer,
    token,
} from '@zillow/constellation';

export const StyledGuaranteeIcon = styled(Image)`
    display: none;

    ${mediaMixin('lg', css`
        display: block;
        margin-right: ${spaceMixin('xs')};
        height: 32px;
        width: 32px;
    `)}
`;

export const StyledMiddleFlex = styled.div`
    display: flex;
    align-items: center;

    ${mediaMixin('lg', css`
        justify-content: space-between;
        flex-grow: 1;
    `)}
`;

export const StyledFlexContainer = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;

    ${mediaMixin('lg', css`
        flex-direction: row;
        align-items: center;
    `)}
`;

export const StyledTagSpacer = styled(Spacer)`
    margin-bottom: 6px;

    ${mediaMixin('md', css`
        margin-bottom: 0px;
    `)}
`;

export const StickyListingFooterContainer = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: ${token('colors.white')};
    z-index: 270;
    box-shadow: 0 0 7px -2px rgba(0, 0, 0, 0), 0 0 3px 0 rgba(0, 0, 0, 0.26);
    border-top: 1px solid ${token('colors.gray300')};
    height: 114px;
    padding: 16px;

    /* 481 */
    ${mediaMixin('md', css`
        height: 76px;
    `)}

    
    /* 769 */
    ${mediaMixin('lg', css`
        padding: 16px 32px;
    `)}

    /* 1024 */
    ${mediaMixin('xl', css`
        padding: 16px 40px;
    `)}

    /* 1281 */
    ${mediaMixin('xxl', css`
        padding: 17px 104px;
    `)}
`;
